/* Bonoboss · boleta/factura. Portado de ReFramed (rf-dte.js, 8-oct-2026) a Impulse. Código propio, sin jQuery ni GAEA.
   Guarda en atributos del carrito (los lee el servicio bonoboss-dte); valida el RUT con módulo 11 y lo deja como 12345678-9.
   Impulse: cajón #CartDrawerForm (dentro de #CartDrawer) y página #CartPageForm; botón button[name=checkout].
   En /cart conviven las dos cajas (carro tipo drawer): cada botón valida SU caja y se sincronizan. */
(function () {
  if (window.__bbDte) return;
  window.__bbDte = true;

  var FACTURA_ATTRS = ['Razón social', 'RUT', 'Giro', 'Dirección facturación', 'Región facturación',
    'Comuna facturación', 'Teléfono facturación', 'Email facturación'];
  var REQUIRED = {
    'Boleta nominativa': ['RUT'],
    'Factura': ['Razón social', 'RUT', 'Giro', 'Dirección facturación', 'Región facturación',
      'Comuna facturación', 'Email facturación']
  };
  // Boleta nominativa (reembolso Isapre/seguro): solo RUT; el nombre sale de la compra.
  function usesAttr(tipo, k) { return tipo === 'Factura' || (tipo === 'Boleta nominativa' && k === 'RUT'); }
  function tipoOf(box) { return box.querySelector('[data-bb-dte-tipo]').value; }
  function applyTipo(box, tipo) {
    box.querySelector('[data-bb-dte-campos]').hidden = tipo === 'Boleta';
    box.querySelector('[data-bb-dte-factura]').hidden = tipo !== 'Factura';
    box.querySelector('[data-bb-dte-nominativa]').hidden = tipo !== 'Boleta nominativa';
    abrir(box);
    var listo = box.querySelector('[data-bb-dte-listo]'); if (listo) listo.hidden = tipo === 'Boleta';
    /* bloque nuevo (19-oct): las 2 opciones reflejan el tipo; con documento queda abierto, con boleta normal cerrado */
    if (box.querySelector('[data-bb-dte-ui]')) {
      box.querySelectorAll('[data-bb-dte-op]').forEach(function (r) { r.checked = r.value === tipo; });
      if (tipo !== 'Boleta') box.classList.add('is-abierto');
      else if (!box.hasAttribute('data-bb-dte-eligiendo')) box.classList.remove('is-abierto');
      var ab = box.querySelector('[data-bb-dte-abrir]'); if (ab) ab.setAttribute('aria-expanded', box.classList.contains('is-abierto') ? 'true' : 'false');
    }
    box.querySelector('[data-bb-dte-error]').hidden = true;
    toggleExpress(tipo !== 'Boleta');
    if (tipo === 'Factura') populate(box);
  }

  // ---- RUT chileno -------------------------------------------------------
  function rutClean(v) { return String(v || '').replace(/[^0-9kK]/g, '').toUpperCase(); }
  function rutDv(body) {
    var sum = 0, mul = 2;
    for (var i = body.length - 1; i >= 0; i--) { sum += Number(body[i]) * mul; mul = mul === 7 ? 2 : mul + 1; }
    var r = 11 - (sum % 11);
    return r === 11 ? '0' : r === 10 ? 'K' : String(r);
  }
  function rutValid(v) {
    var c = rutClean(v);
    if (!/^\d{7,8}[0-9K]$/.test(c)) return false;
    var body = c.slice(0, -1), dv = c.slice(-1);
    if (/^(\d)\1+$/.test(body) || Number(body) === 0) return false;
    return rutDv(body) === dv;
  }
  // Sin puntos, con guion: 12345678-9
  function rutFormat(v) {
    var c = rutClean(v).slice(0, 9);
    return c.length < 2 ? c : c.slice(0, -1) + '-' + c.slice(-1);
  }
  window.bbRut = { clean: rutClean, valid: rutValid, format: rutFormat, dv: rutDv };

  // Aviso en vivo bajo el campo RUT: válido / dígito verificador incorrecto.
  function rutFeedback(box, input) {
    var msg = box.querySelector('[data-bb-dte-rutmsg]');
    var c = rutClean(input.value);
    var state = c.length < 8 ? '' : rutValid(c) ? 'ok' : 'bad';
    input.setAttribute('aria-invalid', state === 'bad' ? 'true' : 'false');
    if (!msg) return;
    msg.className = 'bb-dte__rutok' + (state ? ' is-' + state : '');
    msg.textContent = state === 'ok' ? '✓ RUT válido'
      : state === 'bad' ? '✗ RUT no válido. Revisa el número y el dígito verificador.' : '';
  }

  // ---- Datos de regiones y comunas ----------------------------------------
  var dataPromise = null;
  function loadData(box) {
    if (!dataPromise) {
      dataPromise = fetch(box.getAttribute('data-comunas-url')).then(function (r) { return r.json(); })
        .catch(function () { dataPromise = null; return null; });
    }
    return dataPromise;
  }
  function fillComunas(box, data, regionCode, selected) {
    var sel = box.querySelector('[data-bb-dte-comuna]');
    sel.innerHTML = '<option value="">Selecciona tu comuna</option>';
    var region = data.regiones.filter(function (r) { return r.name === regionCode || r.code === regionCode; })[0];
    if (!region) return;
    (data.comunas[region.code] || []).forEach(function (c) {
      var o = new Option(c, c); if (c === selected) o.selected = true; sel.add(o);
    });
  }
  function initBox(box) {
    if (box.hasAttribute('data-ready')) return;
    box.setAttribute('data-ready', '');
    applyTipo(box, tipoOf(box));
    var r = box.querySelector('[data-rut]'); if (r && r.value) rutFeedback(box, r);
    /* al recargar o reabrir el carro: si el documento ya está completo, se muestra resumido (como tras «Listo») */
    if (tipoOf(box) !== 'Boleta' && completo(box)) plegar(box);
    else if (tipoOf(box) === 'Factura') box._bbPlegarAlCargar = true;   // región y comuna llegan después (populate)
  }
  /* ¿Datos completos y válidos? Sin marcar errores ni mover el foco (para decidir si se muestra resumido) */
  function completo(box) {
    var tipo = tipoOf(box), req = REQUIRED[tipo] || [], ok = true;
    box.querySelectorAll('[data-attr]').forEach(function (el) {
      var k = el.getAttribute('data-attr'), v = (el.value || '').trim();
      if (!usesAttr(tipo, k)) return;
      if ((req.indexOf(k) > -1 && !v) || (k === 'RUT' && !rutValid(v)) || (k === 'Email facturación' && v && !/^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(v))) ok = false;
    });
    return ok;
  }
  function populate(box) {
    if (box.hasAttribute('data-populated')) return;
    loadData(box).then(function (data) {
      if (!data || box.hasAttribute('data-populated')) return;
      box.setAttribute('data-populated', '');
      var rsel = box.querySelector('[data-bb-dte-region]');
      var savedRegion = box.getAttribute('data-region'), savedComuna = box.getAttribute('data-comuna');
      data.regiones.forEach(function (r) {
        var o = new Option(r.name, r.name); if (r.name === savedRegion) o.selected = true; rsel.add(o);
      });
      if (savedRegion) fillComunas(box, data, savedRegion, savedComuna);
      if (box._bbPlegarAlCargar) { box._bbPlegarAlCargar = false; if (completo(box)) plegar(box); }
    });
  }

  // ---- Guardado en el carrito --------------------------------------------
  var saveTimer = null, pending = null;
  function collect(box) {
    var tipo = tipoOf(box);
    var attrs = { 'Documento': tipo };
    box.querySelectorAll('[data-attr]').forEach(function (el) {
      var k = el.getAttribute('data-attr');
      var v = (el.value || '').trim();
      if (k === 'RUT') v = rutValid(v) ? rutFormat(v) : v;
      attrs[k] = usesAttr(tipo, k) ? v : '';
    });
    return attrs;
  }
  function save(box) {
    clearTimeout(saveTimer); saveTimer = null;
    syncOthers(box);
    pending = fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: collect(box) })
    }).catch(function () {}).then(function () { pending = null; });
    return pending;
  }
  function saveLater(box) { syncOthers(box); clearTimeout(saveTimer); saveTimer = setTimeout(function () { save(box); }, 400); }

  // Con factura o boleta nominativa se ocultan los pagos exprés (se saltan este formulario).
  function toggleExpress(hide) {
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function (el) {
      el.style.display = hide ? 'none' : '';
    });
  }

  // ---- Validación ----------------------------------------------------------
  /* «Listo»: pliega los datos en una línea de resumen (el cliente vuelve a ver su carro); «Editar» o un error los abre */
  function abrir(box) {
    box.classList.remove('is-plegado');
    var r = box.querySelector('[data-bb-dte-resumen]'); if (r) r.hidden = true;
  }
  function plegar(box) {
    var r = box.querySelector('[data-bb-dte-resumen]'); if (!r) return;
    var tipo = tipoOf(box), val = function (k) { var el = box.querySelector('[data-attr="' + k + '"]'); return el ? (el.value || '').trim() : ''; };
    r.querySelector('[data-bb-dte-resumen-t]').textContent = tipo === 'Factura'
      ? 'Factura a ' + (val('Razón social') || 'tu empresa') + ' · RUT ' + val('RUT')
      : 'Boleta con tu RUT ' + val('RUT') + ', para Isapre o seguro';
    r.hidden = false;
    box.classList.add('is-plegado');
  }
  function setTipo(box, tipo) {
    var sel = box.querySelector('[data-bb-dte-tipo]');
    if (sel.value === tipo) { applyTipo(box, tipo); return; }
    sel.value = tipo; sel.dispatchEvent(new Event('change', { bubbles: true }));
  }
  /* Abrir el bloque / elegir una opción / «No lo necesito» (vuelve a boleta normal y cierra: nadie queda obligado) */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bb-dte-abrir],[data-bb-dte-no]');
    if (!t) return;
    var box = t.closest('[data-bb-dte]'); if (!box) return;
    if (t.hasAttribute('data-bb-dte-abrir')) {
      box.setAttribute('data-bb-dte-eligiendo', ''); box.classList.add('is-abierto'); t.setAttribute('aria-expanded', 'true');
      var r = box.querySelector('[data-bb-dte-op]'); if (r) r.focus();
      return;
    }
    box.removeAttribute('data-bb-dte-eligiendo'); abrir(box); box.classList.remove('is-abierto');
    setTipo(box, 'Boleta');
    var ab = box.querySelector('[data-bb-dte-abrir]'); if (ab) { ab.setAttribute('aria-expanded', 'false'); ab.focus(); }
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-bb-dte-op]')) return;
    var box = e.target.closest('[data-bb-dte]'); if (box) setTipo(box, e.target.value);
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-bb-dte-listo],[data-bb-dte-editar]');
    if (!t) return;
    var box = t.closest('[data-bb-dte]'); if (!box) return;
    if (t.hasAttribute('data-bb-dte-editar')) { abrir(box); return; }
    if (tipoOf(box) !== 'Boleta' && !validate(box)) return;
    save(box); plegar(box);
  });

  function validate(box) {
    var err = null, first = null, tipo = tipoOf(box), req = REQUIRED[tipo] || [];
    box.querySelectorAll('[data-attr]').forEach(function (el) {
      var k = el.getAttribute('data-attr'), v = (el.value || '').trim(), bad = false;
      if (!usesAttr(tipo, k)) { el.setAttribute('aria-invalid', 'false'); return; }
      if (req.indexOf(k) > -1 && !v) bad = true;
      else if (k === 'RUT' && !rutValid(v)) { bad = true; err = err || 'El RUT no es válido. Revisa el dígito verificador (ej: 12345678-9).'; }
      else if (k === 'Email facturación' && !/^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/.test(v)) { bad = true; err = err || 'Revisa el email para la factura (ej: nombre@empresa.cl).'; }
      else if (k === 'Giro' && /^(false|null|undefined|-+|\.+)$/i.test(v)) { bad = true; err = err || 'Escribe el giro de la empresa (ej: Comercio de artículos ópticos).'; }
      el.setAttribute('aria-invalid', bad ? 'true' : 'false');
      if (bad && !first) first = el;
    });
    var msg = box.querySelector('[data-bb-dte-error]');
    if (first) {
      abrir(box);
      var label = box.querySelector('label[for="' + first.id + '"]');
      msg.textContent = err || ('Completa el campo "' + (label ? label.textContent.trim() : '') + '" para emitir tu ' + (tipo === 'Factura' ? 'factura.' : 'boleta.'));
      if (box.querySelector('[data-bb-dte-no]')) msg.textContent += ' Si no lo necesitas, toca «No lo necesito».';
      msg.hidden = false;
      first.focus();
      return false;
    }
    msg.hidden = true;
    return true;
  }

  // La caja que corresponde al botón de pago: el del cajón (#CartDrawerForm) valida la del cajón; el de la
  // página /cart (#CartPageForm) valida la de la página. En /cart conviven las dos (carro tipo drawer).
  function inDrawer(b) { return !!b.closest('#CartDrawer'); }
  function activeBox(form) {
    var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-bb-dte]'));
    var drawerForm = !!(form && (form.id === 'CartDrawerForm' || form.closest('#CartDrawer')));
    var mine = boxes.filter(function (b) { return inDrawer(b) === drawerForm; });
    return mine[0] || null;
  }

  // Mantiene iguales todas las cajas de la página (cajón y /cart) mientras se escribe.
  function syncOthers(src) {
    var tipo = tipoOf(src);
    var vals = {};
    src.querySelectorAll('[data-attr]').forEach(function (el) { vals[el.getAttribute('data-attr')] = el.value; });
    document.querySelectorAll('[data-bb-dte]').forEach(function (b) {
      if (b === src) return;
      var t = b.querySelector('[data-bb-dte-tipo]');
      if (t.value !== tipo) { t.value = tipo; applyTipo(b, tipo); }
      b.querySelectorAll('input[data-attr]').forEach(function (el) {
        var k = el.getAttribute('data-attr');
        if (k in vals && el.value !== vals[k]) el.value = vals[k];
      });
      var region = vals['Región facturación'] || '', comuna = vals['Comuna facturación'] || '';
      b.setAttribute('data-region', region); b.setAttribute('data-comuna', comuna);
      if (b.hasAttribute('data-populated')) {
        var rs = b.querySelector('[data-bb-dte-region]');
        loadData(b).then(function (data) {
          if (!data) return;
          if (rs.value !== region) rs.value = region;
          fillComunas(b, data, region, comuna);
        });
      }
      var r = b.querySelector('[data-rut]'); if (r) rutFeedback(b, r);
      b.querySelector('[data-bb-dte-error]').hidden = true;
    });
  }

  // ---- Eventos (delegados: el drawer se re-renderiza) ----------------------
  document.addEventListener('change', function (e) {
    var box = e.target.closest && e.target.closest('[data-bb-dte]');
    if (!box) return;
    if (e.target.matches('[data-bb-dte-tipo]')) {
      applyTipo(box, e.target.value);
      save(box);
    } else if (e.target.matches('[data-bb-dte-region]')) {
      loadData(box).then(function (data) { if (data) fillComunas(box, data, e.target.value, null); save(box); });
    } else if (e.target.matches('[data-attr]')) {
      save(box);
    }
  });

  document.addEventListener('input', function (e) {
    var box = e.target.closest && e.target.closest('[data-bb-dte]');
    if (!box || !e.target.matches('[data-attr]')) return;
    box.querySelector('[data-bb-dte-error]').hidden = true;
    if (e.target.matches('[data-rut]')) {
      e.target.value = rutFormat(e.target.value);
      rutFeedback(box, e.target);
    }
    saveLater(box);
  });

  // Bloquea el checkout si la factura está incompleta o el RUT es inválido.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var submitter = e.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    if (form.hasAttribute('data-bb-dte-ok')) { form.removeAttribute('data-bb-dte-ok'); return; }
    var box = activeBox(form);
    if (!box) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (tipoOf(box) !== 'Boleta' && !validate(box)) return;
    save(box).then(function () {
      form.setAttribute('data-bb-dte-ok', '');
      /* Impulse deshabilita «Finalizar pedido» en /cart mientras se guarda el carro: un botón deshabilitado
         no viaja en el envío y Shopify actualiza el carro en vez de ir al checkout. El carro ya quedó guardado. */
      if (submitter.disabled) submitter.disabled = false;
      if (form.requestSubmit) form.requestSubmit(submitter); else submitter.click();
    });
  }, true);

  // Inicializa las instancias actuales y las que traiga cada re-render del drawer.
  function scan() { document.querySelectorAll('[data-bb-dte]:not([data-ready])').forEach(initBox); }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
